import { Alert, Button, Checkbox, Container, Flashbar, FlashbarProps, FormField, Input, LiveRegion, SelectProps, StatusIndicator, Table, Tabs } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, checkHashParam, formatPhone, getCookie, getParameter, getUrlVersion, getUserType, isEmail, isValidPhone, setData, setLoading } from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiCakeVariantOutline, mdiCalendarArrowRight } from '@mdi/js';
import Icon from '@mdi/react';
import BadgeUserType from '../../../../components/extras/BadgeUserType';
import UserAvatar from '../../../../components/extras/UserAvatar';
import PhoneInput from '../../../../components/PhoneInput';
import SelectCountry from '../../../../components/selects/selectCountry';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemCheck, ItemsGroups, ItemUser } from '../../../../resources/types';


type OptionDefinition = SelectProps.Option;

export const UserProfilePage = () => {
    const { idUser, data, menu } = useGlobalState();

    type OptionDefinition2 = {
        label: string;
        value: string;
    };



    //const storeAdmin = useStoreAdmin();

    const [pendingJobCreation, setPendingJobCreation] = useState(false);
    const [activaTab, setActiveTab] = useState("data");
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();

    const [user, setUser] = useState<ItemUser>();

    const [userMessages, setUserMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [selectedGroups, setSelectedGroups] = React.useState<OptionDefinition[]>([]);
    const [selectedCharges, setSelectedCharges] = React.useState<OptionDefinition[]>([]);

    const [masterGroups, setMasterGroups] = useState()
    const [masterCharges, setMasterCharges] = useState()
    const [isPax, setIsPax] = useState(0)
    const [isShifts, setIsShifts] = useState(0)


    useEffect(() => {
        if (data && data.groups) {
            const groups = data.groups.map((group: { group: any; idGroup: { toString: () => any; }; }) => ({
                label: group.group,
                value: group.idGroup.toString(),
            }));
            setMasterGroups(groups)
        }
        if (data && data.charges) {
            const charges = data.charges.map((charge: { currency: string; value: number; isActiveCharge: number; charge: any; idCharge: { toString: () => any; }; }) => ({
                label: charge.charge,
                value: charge.idCharge.toString(),
                disabled: charge.isActiveCharge === 0,
                description: `${charge.currency} ${charge.value}`
            }));
            setMasterCharges(charges)
        }

    }, []);

    useEffect(() => {
        handleGetData();
    }, [idUser]);


    const handlePhoneFocus1 = () => {
        if (!user) return
        setUser({ ...user, phone1: user?.phone1.replace(/\D/g, '') });
    };
    const handlePhoneFocus2 = () => {
        if (!user) return
        setUser({ ...user, phone2: user?.phone2.replace(/\D/g, '') });
    };
    const handlePhoneFocusICE = () => {
        if (!user) return
        setUser({ ...user, ICEPhone: user?.ICEPhone.replace(/\D/g, '') });
    };
    const handlePhoneBlur1 = () => {
        if (!user) return
        if (isValidPhone(user?.phone1)) {
            setUser({ ...user, phone1: formatPhone(user?.phone1) });
        }
    };

    const handlePhoneBlur2 = () => {
        if (!user) return
        if (isValidPhone(user?.phone2)) {
            setUser({ ...user, phone2: formatPhone(user?.phone2) });
        }
    };

    const handlePhoneBlurICE = () => {
        if (!user) return
        if (isValidPhone(user?.ICEPhone)) {
            setUser({ ...user, ICEPhone: formatPhone(user?.ICEPhone) });
        }
    };


    const handleUpdateUser = async () => {
        let msg: FlashbarProps.MessageDefinition[] = [];
        if (user?.phone1 === "")
            msg.push({
                type: "error",
                content: 'Teléfono primario no puede estar vacío',
            })
        if (user?.phone1 !== "" && !isValidPhone(user?.phone1))
            msg.push({
                type: "error",
                content: 'Teléfono primario inválido',
            })
        if (user?.email === "")
            msg.push({
                type: "error",
                content: 'Email primario no puede estar vacío',
            })
        if (user?.email !== "" && !isEmail(user?.email || ""))
            msg.push({
                type: "error",
                content: 'Email primario inválido',
            })
        if (user?.email2 !== "" && !isEmail(user?.email2 || ""))
            msg.push({
                type: "error",
                content: 'Email alternativo inválido',
            })
        if (user?.email !== "" && user?.email2 !== "" && isEmail(user?.email || "") && isEmail(user?.email2 || "") && user?.email === user?.email2)
            msg.push({
                type: "error",
                content: 'Email primario no puede ser identico al email alternativo inválido',
            })
        setUserMessages(msg)
        if (msg.length > 0) {
            return;
        }
        if (user) {
            user.phone1 = user.phone1.replace(/\D/g, '');
            user.ICEPhone = user.ICEPhone.replace(/\D/g, '');
            user.phone2 = user.phone2.replace(/\D/g, '');
        }
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/profile/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(
                    user && {
                        phone1: user.phone1,
                        ICEPhone: user.ICEPhone,
                        phone2: user.phone2,
                        ICEContact: user.ICEContact,
                        email: user.email,
                        email2: user.email2,
                        // 2. Add or overwrite the new properties
                        isPax: isPax,
                        isShifts: isShifts,
                    }
                ),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                if (data.user.dateBirth) {
                    //data.user.dateBirth = parseDotNetDate(data.user.dateBirth);
                }
                if (data.user.dateMember) {
                    //data.user.dateMember = parseDotNetDate(data.user.dateMember);
                }
                setUser(data.user)

                if (data.user.charges.fixed) {
                    const charges = data.user.charges.fixed.map((charge: { currency: string; value: number; charge: any; idCharge: { toString: () => any; }; }) => ({
                        label: charge.charge,
                        value: charge.idCharge.toString(),
                        description: `Grupo: ${charge.value}`
                    }));
                    setSelectedCharges(charges)
                }
                if (data.user.groups) {
                    const groups = data.user.groups.map((group: { group: any; idGroup: { toString: () => any; }; }) => ({
                        label: group.group,
                        value: group.idGroup.toString(),
                    }));
                    setSelectedGroups(groups)
                }
                if (getParameter(window.location.hash, "returnUrl") !== "") {
                    navigate(decodeURIComponent(getParameter(window.location.hash, "returnUrl")).replace("#", ""));
                }

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleGetData = async () => {
        if (idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/profile/get',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        movements: true,
                        bookings: true,
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    if (data.user.dateBirth) {
                        //data.user.dateBirth = parseDotNetDate(data.user.dateBirth);
                    }
                    if (data.user.dateMember) {
                        //data.user.dateMember = parseDotNetDate(data.user.dateMember);
                    }

                    if (data.user) {
                        data.user.phone1 = formatPhone(data.user?.phone1);
                        data.user.phone2 = formatPhone(data.user?.phone2);
                        data.user.ICEPhone = formatPhone(data.user?.ICEPhone);
                    }
                    setUser(data.user)
                    if (data.user.charges.fixed) {
                        const charges = data.user.charges.fixed.map((charge: { currency: string; value: number; charge: any; idCharge: { toString: () => any; }; }) => ({
                            label: charge.charge,
                            value: charge.idCharge.toString(),
                            description: `Grupo: ${charge.value}`
                        }));
                        setSelectedCharges(charges)
                    }
                    if (data.user.groups) {
                        const groups = data.user.groups.map((group: { group: any; idGroup: { toString: () => any; }; }) => ({
                            label: group.group,
                            value: group.idGroup.toString(),
                        }));
                        setSelectedGroups(groups)
                    }
                    if (!data && !data.user) return
                    let updatedUser = { ...data.user };
                    if (isValidPhone(updatedUser.phone1)) {
                        updatedUser.phone1 = formatPhone(data.user?.phone1);
                    }
                    if (isValidPhone(data.user?.phone2)) {
                        updatedUser.phone2 = formatPhone(data.user?.phone2);
                    }
                    if (isValidPhone(data.user?.ICEPhone)) {
                        updatedUser.ICEPhone = formatPhone(data.user?.ICEPhone);
                    }
                    setUser(updatedUser);
                    setIsShifts(data.user?.groups.some((group: ItemsGroups) => group.idGroup === 135036) ? 1 : 0)
                    setIsPax(data.user?.groups.some((group: ItemsGroups) => group.idGroup === 2209059) ? 1 : 0)

                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }


    return (

        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">

                        {user && (
                            <SpaceBetween direction='vertical' size='xs'>
                                {checkHashParam("NIU") === "1" && (
                                    <Alert type="warning" header="Actualización de información">
                                        Estimado usuario, nuestros registros indican que su información personal de contacto debe ser revisada y confirmada al menos cada 60 días (Última actualización: <b>{user?.dateLastUpdatedInfo}</b>). Le pedimos confirmar o modificar la información indicada más abajo, a fin de mantener sus registros actualizados.
                                    </Alert>
                                )}

                                <Header
                                    actions={<UserAvatar idUser={user?.idUser || 0} width={35} />}
                                    variant="h2"
                                    info={<BadgeUserType idUserType={user?.idUserType || 0} />}
                                    description={
                                        user && user.needsInfoUpdate && (
                                            <Flashbar items={[{
                                                type: "error",
                                                content: "Confirme o actualice su información de contacto",
                                                id: "profile-complete-success",
                                                dismissible: false
                                            }]}

                                            />
                                        )
                                    }
                                >
                                    {user?.displayName}
                                </Header>
                                <Tabs
                                    onChange={(event) => { setActiveTab(event.detail.activeTabId) }}
                                    activeTabId={activaTab}
                                    key={"id"}
                                    tabs={[{

                                        label: "Ficha",
                                        id: "data",
                                        content: (
                                            <SpaceBetween direction='vertical' size="s">
                                                <Flashbar items={userMessages} />
                                                <Container header={<Header variant='h3'>General</Header>}>
                                                    <SpaceBetween direction='horizontal' size="s">
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField

                                                                label={<>{"RUT"}</>}

                                                            /*label={<>{"RUT"}<Link href={`#admin/users?idUser=${user?.RUT}`} external variant="primary" ></Link></>}*/
                                                            >
                                                                <Input value={user?.RUT || ""} readOnly />
                                                            </FormField>
                                                        </div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Apellidos">
                                                                <Input value={user?.lastName || ""} readOnly />
                                                            </FormField></div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Nombres">
                                                                <Input value={user?.name || ""} readOnly />
                                                            </FormField>
                                                        </div>
                                                    </SpaceBetween>
                                                </Container>
                                                <Container header={<Header variant='h3'>Contacto</Header>}>
                                                    <SpaceBetween direction='horizontal' size="s">
                                                        <div style={{ maxWidth: 150 }}>
                                                            <FormField label="Teléfono" constraintText="Formato 56XXXXXXXXX">

                                                                <PhoneInput value={user?.phone1 || ""}
                                                                    key={"PHONE1"}
                                                                    width={150}
                                                                    onChange={(phone) => {
                                                                        if (user)
                                                                            setUser({ ...user, phone1: phone });
                                                                    }} />
                                                            </FormField>
                                                        </div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Email">
                                                                <Input value={user?.email || ""}
                                                                    invalid={user && user?.email !== "" && !isEmail(user?.email || "*")}
                                                                    onChange={(event) => {
                                                                        if (user)
                                                                            setUser({ ...user, email: event.detail.value.toLocaleLowerCase() });

                                                                    }} />
                                                            </FormField>
                                                        </div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Email Alt." constraintText="Opcional">
                                                                <Input value={user?.email2 || ""}
                                                                    invalid={user && user?.email2 !== "" && !isEmail(user?.email2 || "*")}
                                                                    onChange={(event) => {
                                                                        if (user)
                                                                            setUser({ ...user, email2: event.detail.value.toLocaleLowerCase() });
                                                                        // setFineExclude(detail.checked ? 1 : 0)
                                                                    }} />
                                                            </FormField>
                                                        </div>

                                                        <div style={{ maxWidth: 150 }}>
                                                            <FormField label="Nacionalidad">
                                                                <SelectCountry value={user?.idCountry || null} onSelect={(id) => {
                                                                    if (user)
                                                                        setUser({ ...user, idCountry: id });
                                                                }} />
                                                            </FormField>
                                                        </div>
                                                    </SpaceBetween>
                                                </Container>

                                                <Container header={<Header variant='h3'>Estado</Header>} footer={<small>Ante cualquier discrpencia, informar a la oficina de administración</small>}>
                                                    <SpaceBetween direction='horizontal' size="s">

                                                        <div>
                                                            <FormField label={<><Icon path={mdiCakeVariantOutline} size={0.75} /> Nacimiento</>}
                                                                constraintText={user?.age ? `${user.age} años` : ""}

                                                            >
                                                                <Input readOnly value={user?.dateBirth ?? ""}
                                                                />
                                                            </FormField></div>
                                                        <div>
                                                            <FormField label={<><Icon path={mdiCalendarArrowRight} size={0.75} /> Ingreso</>}>
                                                                <Input readOnly value={user?.dateMember ?? ""}
                                                                />
                                                            </FormField></div>
                                                        <div><FormField label="Tipo de usuario">
                                                            <Input readOnly value={getUserType(user?.idUserType, data).userType || ""} />
                                                        </FormField></div>

                                                        <div><FormField label="Estado">
                                                            <Checkbox readOnly checked={user?.isActiveUser === 1} >Activo</Checkbox>
                                                        </FormField></div>

                                                    </SpaceBetween>
                                                </Container>

                                                <LiveRegion>
                                                    <Alert
                                                        type="error"
                                                        header="Contacto ICE">
                                                        <SpaceBetween direction='horizontal' size="s">
                                                            <div style={{ maxWidth: 300 }}>
                                                                <FormField label="Nombre" constraintText="Persona a contactar en caso de emergencia">
                                                                    <Input value={user?.ICEContact || ""}
                                                                        onChange={(event) => {
                                                                            if (user) {
                                                                                setUser({ ...user, ICEContact: event.detail.value });
                                                                            }
                                                                            // setFineExclude(detail.checked ? 1 : 0)
                                                                        }}

                                                                        autoComplete={false}

                                                                    />
                                                                </FormField>
                                                            </div>
                                                            <div style={{ maxWidth: 150 }}>
                                                                <FormField label="Teléfono">

                                                                    <PhoneInput value={user?.ICEPhone || ""}
                                                                        key={"ICEPHONE"}
                                                                        width={150}
                                                                        onChange={(phone) => {
                                                                            if (user)
                                                                                setUser({ ...user, ICEPhone: phone });
                                                                        }} />
                                                                </FormField></div>
                                                        </SpaceBetween>

                                                    </Alert>
                                                </LiveRegion>
                                                <Container header={<Header variant='h3'>Estado</Header>}>
                                                    <SpaceBetween direction='vertical' size="s">
                                                        {user && user.groups && (

                                                            <FormField label="PAXs"
                                                                constraintText={
                                                                    <> {/* Use a React Fragment or a <div> */}
                                                                        <span>
                                                                            Suscripción al grupo de mercenarios PAXs para recibir notificaciones y asignaciones.
                                                                        </span>
                                                                        {isPax === 0 && user?.groups.some((group: ItemsGroups) => group.idGroup === 2209059) && (
                                                                            <StatusIndicator type="warning">
                                                                                Si usted se encuentra suscrito, se desinscribe y luego se inscribe nuevamente, perderá su historial de asignaciones anteriores de paxs y pasará al final de la lista de espera.
                                                                            </StatusIndicator>
                                                                        )}
                                                                    </>
                                                                }
                                                                errorText={user?.checks.some((check: ItemCheck) => check.idCheck === 1118437 && check.statusRequest === 3) ? null : user?.groups.some((group: ItemsGroups) => group.idGroup === 2209059) ? "" : <>Debe tener el chequeo <strong>pasajero planeador</strong>.</>}
                                                            >
                                                                <Checkbox checked={isPax === 1}

                                                                    disabled={user?.checks.some((check: ItemCheck) => (check.idCheck === 1118437 || check.idCheck === 1105) && check.statusRequest === 3) ? false : true}
                                                                    onChange={(event) => {
                                                                        setIsPax(event.detail.checked ? 1 : 0);
                                                                        //console.log(user?.groups.some((group: ItemsGroups) => group.idGroup === 2209059))
                                                                    }}

                                                                >Suscrito al grupo PAXs mercenarios</Checkbox>
                                                            </FormField>
                                                        )}
                                                        {user && user.groups && (
                                                            <FormField label="Turnos"
                                                                constraintText={
                                                                    <> {/* Use a React Fragment or a <div> */}
                                                                        <span>
                                                                            Suscripción al grupo de mercenarios Turnos para recibir notificaciones y asignaciones.
                                                                        </span>
                                                                        {isShifts === 0 && user?.groups.some((group: ItemsGroups) => group.idGroup === 135036) && (
                                                                            <StatusIndicator type="warning">
                                                                                Si usted se encuentra suscrito, se desinscribe y luego se inscribe nuevamente, perderá su historial de asignaciones anteriores de turnos y pasará al final de la lista de espera.
                                                                            </StatusIndicator>
                                                                        )}
                                                                    </>
                                                                }
                                                                errorText={user.idUserType === 12 ? "" : <>Solo socios activos pueden subscribirse a grupo <strong>Mercenarios</strong></>}
                                                            >
                                                                <Checkbox checked={isShifts === 1}
                                                                    disabled={user.idUserType === 12 ? false : true}
                                                                    onChange={(event) => {
                                                                        setIsShifts(event.detail.checked ? 1 : 0);
                                                                    }}

                                                                >Suscrito al grupo mercenarios turnos</Checkbox>
                                                            </FormField>
                                                        )}
                                                    </SpaceBetween>
                                                </Container>
                                                <Box textAlign='right'><Button variant="primary" onClick={() => {
                                                    handleUpdateUser();
                                                }}>Guardar</Button></Box>
                                            </SpaceBetween>
                                        )
                                    },
                                    {
                                        label: "Grupos",
                                        id: "groups",
                                        content: (
                                            <Table
                                                variant='embedded'
                                                columnDefinitions={[
                                                    {
                                                        id: "groups",
                                                        header: "Grupo",
                                                        cell: item => item.group,
                                                    },
                                                ]}
                                                items={user?.metaData?.groups ?? []}
                                                empty={
                                                    <Box
                                                        margin={{ vertical: "xs" }}
                                                        textAlign="center"
                                                        color="inherit"
                                                    >
                                                        <SpaceBetween size="m">
                                                            <b>Sin grupos asociados</b>
                                                        </SpaceBetween>
                                                    </Box>
                                                }
                                            />
                                        )
                                    },
                                    {
                                        label: "Cargos",
                                        id: "charges",
                                        content: (
                                            <Table
                                                variant='embedded'

                                                columnDefinitions={[
                                                    {
                                                        id: "charge",
                                                        header: "Cargo",
                                                        cell: item => item.charge,
                                                    },
                                                    {
                                                        id: "accountPlan",
                                                        header: "Cuenta",
                                                        cell: item => item?.accountPlan
                                                    },
                                                    {
                                                        id: "ammount",
                                                        header: "Monto",
                                                        cell: item => item.currency + " " + item.ammount.toLocaleString('es-CL', {
                                                            style: 'currency',
                                                            maximumFractionDigits: (item.currency === 'CLP' ? 0 : 2)
                                                        }),

                                                    }
                                                ]}
                                                trackBy="idCharge"
                                                items={user?.metaData?.charges ?? []}
                                                empty={
                                                    <Box
                                                        margin={{ vertical: "xs" }}
                                                        textAlign="center"
                                                        color="inherit"
                                                    >
                                                        <SpaceBetween size="m">
                                                            <b>Sin cargos asociados</b>
                                                        </SpaceBetween>
                                                    </Box>
                                                }
                                            />
                                        )
                                    },
                                    ]}
                                />
                            </SpaceBetween>
                        )}
                    </SpaceBetween>



                </>
            }
        />
    );
};
